import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { ChangeMemberPayload } from '@modules/groups-of-admins/submodules/edit/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { GROUPS_OF_ADMINS_PERMISSIONS } from '@modules/groups-of-admins/constants';
import { GROUPS_OF_ADMINS_CREATE_QUERY_KEY } from '@modules/groups-of-admins/submodules/create/constants';
import {
  GROUPS_OF_ADMINS_ADD_MUTATION_API_URL,
  GROUPS_OF_ADMINS_CHANGE_MUTATION_KEY,
  GROUPS_OF_ADMINS_REMOVE_MUTATION_API_URL,
} from '@modules/groups-of-admins/submodules/edit/constants';
import { GroupMemberAction } from '@modules/groups-of-admins/submodules/edit/enums';
import { useToastStore } from '@modules/toast/store';

export default function useGroupsOfAdminsChangeMemberMutation(): IContextMutationResult<
  void,
  Error,
  ChangeMemberPayload
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, ChangeMemberPayload>({
    mutationKey: [GROUPS_OF_ADMINS_CHANGE_MUTATION_KEY],
    mutationFn: ({ action, id, ...payload }) => fetchPost<void>(
      action === GroupMemberAction.ADD
        ? GROUPS_OF_ADMINS_ADD_MUTATION_API_URL
        : GROUPS_OF_ADMINS_REMOVE_MUTATION_API_URL,
      payload,
      {
        permission: GROUPS_OF_ADMINS_PERMISSIONS.EDIT,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [GROUPS_OF_ADMINS_CREATE_QUERY_KEY] });
      displayPresetToast('success');
    },
  });
}
